// refactored details display component
// that gets a title and {key: "value"} pair objects
// and displays it in front end in a group

import { checkKnownDateOrString } from "../";
import _ from "lodash";
import Grid from "@mui/material/Grid";

export function DetailsDisplay({ title, data, gridProps }) {
  return (
    <Grid item {...gridProps}>
      {/* Displays title for the group */}
      <span>
        <b>{title}</b>
      </span>
      {/*
      maps through the object
      creates a grid item with key and value
      capitalises the key and adds a colon
      checks the value if its a date or a string and processes it accordingly 
      */}
      {Object.keys(data).map((oneKey, i) => {
        return (
          <Grid container key={i}>
            <Grid item xs={12} sm={5}>
              <span>{_.startCase(Object.keys(data)[i]) + ":"}</span>
            </Grid>

            <Grid item xs={12} sm={7}>
              <span>{checkKnownDateOrString(oneKey, data[oneKey])}</span>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
}
